export default __webpack_public_path__ + "static/media/agent.f529ff5d.svg";